/* Get Arp Entries Columns */
export const GET_INSTALLED_SOFTWARE_COLUMNS_REQUEST = 'GET_INSTALLED_SOFTWARE_COLUMNS_REQUEST';
export const GET_INSTALLED_SOFTWARE_COLUMNS_SUCCESS = 'GET_INSTALLED_SOFTWARE_COLUMNS_SUCCESS';
export const GET_INSTALLED_SOFTWARE_COLUMNS_FAILURE = 'GET_INSTALLED_SOFTWARE_COLUMNS_FAILURE';

/* Get Arp Entries */
export const GET_INSTALLED_SOFTWARE_REQUEST = 'GET_INSTALLED_SOFTWARE_REQUEST';
export const GET_INITIAL_INSTALLED_SOFTWARE_SUCCESS = 'GET_INITIAL_INSTALLED_SOFTWARE_SUCCESS';
export const GET_INSTALLED_SOFTWARE_SUCCESS = 'GET_INSTALLED_SOFTWARE_SUCCESS';
export const GET_INSTALLED_SOFTWARE_FAILURE = 'GET_INSTALLED_SOFTWARE_FAILURE';

/* Save Search Parameters */
export const SAVE_INSTALLED_SOFTWARE_SEARCH_PARAMETERS = 'SAVE_INSTALLED_SOFTWARE_SEARCH_PARAMETERS';

/* Select Arp Entries */
export const SELECT_INSTALLED_SOFTWARE_SUCCESS = 'SELECT_INSTALLED_SOFTWARE_SUCCESS';

export const SELECT_ALL_INSTALLED_SOFTWARE_SUCCESS = 'SELECT_ALL_INSTALLED_SOFTWARE_SUCCESS';
